import { render } from "./PixKeysContainer.vue?vue&type=template&id=f33ada24&scoped=true"
import script from "./PixKeysContainer.vue?vue&type=script&lang=js"
export * from "./PixKeysContainer.vue?vue&type=script&lang=js"

import "./PixKeysContainer.vue?vue&type=style&index=0&id=f33ada24&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33ada24"]])

export default __exports__